import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Terms.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            <div className="terms-container">
                <div className="terms-header">
                    <h1>개인정보처리방침</h1>
                    <button className="back-button" onClick={() => navigate(-1)}>
                        뒤로가기
                    </button>
                </div>
                
                <div className="terms-content">
                    <div className="terms-section">
                        <p>제정 2025. 08. 01.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제1조(개인정보 처리목적)</h2>
                        <p>주식회사 스마트건강도시랩(이하 '회사'라 함)은 스마트건강코치 V-Care 서비스 및 관련 서비스를 제공하기 위하여 회원의 개인정보를 처리하고 있으며 그 목적 이외의 용도로는 개인정보를 이용하지 않습니다. 회사는 개인정보보호법에 따라 정보주체의 개인정보를 처리합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제2조(개인정보 수집 및 이용 목적)</h2>
                        <p>회사는 아래의 각 업무를 위해 정보주체의 동의 하에 다음과 같은 개인정보를 수집합니다.</p>
                        <p>1. 회원(보호자) 가입, 관리 및 사용자(보호를 받는 자) 건강 관련 상세 정보 조회</p>
                        <p>• 필수: 이름(보호자, 사용자), 휴대폰번호(보호자, 사용자), CI(Connecting Information, 연계정보)</p>
                    </div>

                    <div className="terms-section">
                        <h2>제3조(개인정보의 보유 및 이용기간)</h2>
                        <p>1. 회사는 회원의 본 서비스 탈퇴 시 지체없이 회원의 개인정보를 복구할 수 없는 방식으로 파기하는 것을 원칙으로 합니다.</p>
                        <p>2. 위 1.에도 불구하고 아래의 경우 회사는 회원의 개인정보를 아래의 보유기간 동안 보관합니다.</p>
                        <p>1) 부정 이용 방지, 서비스 이용 기간 관련 분쟁 해결</p>
                        <p>• 보유 기간: 회원 탈퇴 완료일로부터 2년</p>
                        <p>• 보유 정보: 휴대폰번호, 서비스 이용기록, 접속로그, 접속 IP 정보</p>
                        <p>• 근거: 회사 내부 방침</p>
                    </div>

                    <div className="terms-section">
                        <h2>제4조(개인정보처리 위탁)</h2>
                        <p>회사는 개인정보처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
                        <p>1. 클라우드 서비스</p>
                        <p>• 수탁자: 네이버클라우드 주식회사</p>
                        <p>• 위탁하는 업무의 내용: 클라우드 서버 운영 및 관리</p>
                        <p>• 위탁기간: 서비스 제공 기간</p>
                        <p>2. 문자메시지 발송 서비스</p>
                        <p>• 수탁자: 네이버클라우드 주식회사</p>
                        <p>• 위탁하는 업무의 내용: Simple & Easy Notification Service를 이용한 건강정보 알림 문자 발송</p>
                        <p>• 위탁기간: 서비스 제공 기간</p>
                    </div>

                    <div className="terms-section">
                        <h2>제5조(정보주체의 권리 행사)</h2>
                        <p>정보주체는 회사에 대하여 아래와 같은 본인의 개인정보와 관련된 권리를 행사할 수 있습니다. 아래의 권리 행사는 회사의 개인정보 보호책임자 또는 개인정보 보호 담당부서(제7조 참고)를 통해 가능합니다.</p>
                        <p>1. 개인정보 처리현황 통지요구</p>
                        <p>2. 개인정보 열람요구</p>
                        <p>3. 개인정보 정정⋅삭제요구</p>
                        <p>4. 개인정보 처리정지 요구</p>
                    </div>

                    <div className="terms-section">
                        <h2>제6조(개인정보의 파기)</h2>
                        <p>1. 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
                        <p>2. 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제7조(개인정보 보호책임자)</h2>
                        <p>1. 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                        <p>(1) 개인정보 보호책임자</p>
                        <p>• 성명: 유병엽</p>
                        <p>• 직책: 팀장</p>
                        <p>• 연락처</p>
                        <p>전화번호) 070-4348-0881</p>
                        <p>이메일) byyoo@shcl.co.kr</p>
                        <p>Fax) 02-6971-8001</p>
                        <p>(2) 개인정보 보호 담당부서</p>
                        <p>• 부서명: 개발팀</p>
                        <p>• 담당자: 김기윤</p>
                        <p>• 연락처</p>
                        <p>전화번호) 070-4348-0881</p>
                        <p>이메일) kykim@shcl.co.kr</p>
                        <p>Fax) 02-6971-8001</p>
                        <p>2. 정보주체는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>부칙(2025. 08. 01.)</h2>
                        <p>이 개인정보처리방침은 2025년 08월 01일부터 시행한다.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 